import type { IconProps } from '../types/IconProps.ts';
export const Columns3: IconProps = {
    name: 'Columns3',
    children: [
        `<rect width="18" height="18" x="3" y="3" rx="2" />`,
        `<path d="M9 3v18M15 3v18" />`,
    ]
};